import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TokenImage',
  props: {
  cid: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const src = computed(() => `https://ipfs.superk8s.de/ipfs/${props.cid}`);

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createBlock(_component_v_img, {
    src: src.value,
    class: "flex-grow-0 bg-black rounded-xl",
    "aspect-ratio": "1",
    contain: ""
  }, null, 8, ["src"]))
}
}

})